export type SendAnalyticsToAuxiaProps = {
    anonymousId: string;
    treatmentTrackingId: string;
    treatmentId: string;
    interactionType: string;
    interactionTimeMicros: string;
    actionName?: string;
};

const setWindowAnalyticsObject = ({
    interactionType,
    wasSent
}: {
    interactionType: string;
    wasSent: boolean;
}) => {
    if (interactionType === "VIEWED") {
        // @ts-ignore
        window.sentViewedAuxiaAnalytics = wasSent.toString();
    } else if (interactionType === "CLICKED") {
        // @ts-ignore
        window.sentClickedAuxiaAnalytics = wasSent.toString();
    }
};

export const convertDateTimeToInteractionTimeMicros = (dateTime: number) => {
    const microSeconds = dateTime * 1000;
    return microSeconds.toString();
};

export const sendAnalyticsToAuxia = async ({
    anonymousId,
    treatmentTrackingId,
    treatmentId,
    interactionType,
    interactionTimeMicros,
    actionName
}: SendAnalyticsToAuxiaProps) => {
    const url = "https://apis.auxia.io/v1/LogTreatmentInteraction";

    const auxiaRequest = {
        projectId: process.env["AUXIA_PROJECT_ID"] as string,
        userId: anonymousId,
        treatmentTrackingId: treatmentTrackingId,
        treatmentId: treatmentId,
        surface: "LANDING_PAGE_JSM",
        interactionType: interactionType,
        interactionTimeMicros: interactionTimeMicros,
        languageCode: "en",
        actionName: actionName || ""
    };

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": process.env["AUXIA_X_API_KEY"] as string
            },
            body: JSON.stringify(auxiaRequest)
        });

        const data = await response.json();
        const stringData = JSON.stringify(data);

        const responseContainsError = stringData !== "{}";
        if (responseContainsError) {
            throw Error(
                `Auxia did not properly receive analytics: ${stringData}`
            );

            setWindowAnalyticsObject({
                interactionType: interactionType,
                wasSent: false
            });
        }

        setWindowAnalyticsObject({
            interactionType: interactionType,
            wasSent: true
        });
    } catch (e) {
        console.error(`sendAnalyticsToAuxia call error:
                        Request Body: ${JSON.stringify(auxiaRequest)}
                        Error: ${e}
                    `);
    }
};
